import React, { useContext, useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import styled from 'styled-components';

import { MembershipPlansContext } from '../../contexts/MembershipPlansContext';

const StyledBold = styled.span`
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  line-height: 22px;
`;

const DeleteMembershipPlan = props => {
  const { deleteMembershipPlan, response, setResponse } = useContext(
    MembershipPlansContext
  );
  const {
    modalVisible,
    setModalVisible,
    modal,
    selectedMembershipPlan,
    setSelectedMembershipPlan
  } = props;
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);

  const closeModal = () => {
    setModalVisible(false);
    setSelectedMembershipPlan({});
  };

  const handleOk = () => {
    setLoading(true);
    deleteMembershipPlan(selectedMembershipPlan.id);
  };

  const handleCancel = () => {
    setResponse({});
    setLoading(false);
    closeModal();
  };

  useEffect(() => {
    if (modal === 'delete') {
      if (
        response.requestFor === 'get single' &&
        response.requestInProgress === true
      ) {
        setInitialLoading(true);
      } else if (
        response.requestFor === 'get single' &&
        response.requestInProgress === false
      ) {
        setInitialLoading(false);
      }

      if (
        response.requestFor === 'delete' &&
        response.requestInProgress === false &&
        !response.errors
      ) {
        closeModal();
      }

      if (
        response.requestFor === 'delete' &&
        response.requestInProgress === false
      ) {
        setLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  if (modal === 'delete') {
    return (
      <Modal
        title={`Delete ${selectedMembershipPlan.name}`}
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Spin spinning={initialLoading}>
          <p>
            This operation will permanently delete{' '}
            <StyledBold>
              {selectedMembershipPlan.name
                ? selectedMembershipPlan.name.toUpperCase()
                : null}
            </StyledBold>
            !
          </p>
          <p>Are you sure you want to continue?</p>
        </Spin>
      </Modal>
    );
  } else {
    return null;
  }
};

export default DeleteMembershipPlan;
